
// @ts-nocheck
import locale_uk_46json_4b456341 from "#nuxt-i18n/4b456341";

export const localeCodes =  [
  "uk"
]

export const localeLoaders = {
  uk: [
    {
      key: "locale_uk_46json_4b456341",
      load: () => Promise.resolve(locale_uk_46json_4b456341),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/e825ec7b" /* webpackChunkName: "config_i18n_46config_46ts_e825ec7b" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "uk",
      countryCode: "ua",
      iso: "uk-UA",
      name: "Українська",
      files: [
        {
          path: "/app/build/projects/Kredo/locales/uk.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "uk",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "bnz_locale",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  messages: {
    uk: {
      $vuetify: {
        badge: "Значок",
        open: "Відкрити",
        close: "Закрити",
        dismiss: "Відхилити",
        confirmEdit: {
          ok: "ОК",
          cancel: "Скасувати"
        },
        dataIterator: {
          noResultsText: "В результаті пошуку нічого не знайдено",
          loadingText: "Завантаження..."
        },
        dataTable: {
          itemsPerPageText: "Рядків на сторінці:",
          ariaLabel: {
            sortDescending: "Відсортовано за спаданням.",
            sortAscending: "Відсортовано за зростанням.",
            sortNone: "Не відсортовано.",
            activateNone: "Активувати, щоб видалити сортування.",
            activateDescending: "Активувати, щоб відсортувати за спаданням.",
            activateAscending: "Активувати, щоб відсортувати за зростанням."
          },
          sortBy: "Відсортувати за"
        },
        dataFooter: {
          itemsPerPageText: "Елементів на сторінці:",
          itemsPerPageAll: "Всі",
          nextPage: "Наступна сторінка",
          prevPage: "Попередня сторінка",
          firstPage: "Перша сторінка",
          lastPage: "Остання сторінка",
          pageText: "{0}-{1} з {2}"
        },
        dateRangeInput: {
          divider: "до"
        },
        datePicker: {
          itemsSelected: "Вибрано {0}",
          range: {
            title: "Оберіть дати",
            header: "Введіть дати"
          },
          title: "Оберіть дату",
          header: "Введіть дату",
          input: {
            placeholder: "Введіть дату"
          },
          ariaLabel: {
            previousMonth: "Попередній місяць",
            nextMonth: "Наступний місяць",
            selectYear: "Виберіть рік",
            selectDate: "{0}",
            currentDate: "Сьогодні, {0}"
          }
        },
        noDataText: "Немає даних для відображення",
        carousel: {
          prev: "Попередній слайд",
          next: "Наступий слайд",
          ariaLabel: {
            delimiter: "Слайд {0} з {1}"
          }
        },
        calendar: {
          moreEvents: "Ще {0}",
          today: "Сьогодні"
        },
        input: {
          clear: "Очистити {0}",
          prependAction: "{0} попередня дія",
          appendAction: "{0} наступна дія",
          otp: "Будь ласка, введіть символ OTP {0}"
        },
        fileInput: {
          counter: "{0} файлів",
          counterSize: "{0} файлів ({1} загалом)"
        },
        fileUpload: {
          title: "Перетягніть файли сюди",
          divider: "або",
          browse: "Переглянути файли"
        },
        timePicker: {
          am: "AM",
          pm: "PM",
          title: "Оберіть час"
        },
        pagination: {
          ariaLabel: {
            root: "Навігація по сторінках",
            next: "Наступна сторінка",
            previous: "Попередня сторінка",
            page: "Перейти на сторінку {0}",
            currentPage: "Поточна сторінка, Сторінка {0}",
            first: "Перша сторінка",
            last: "Остання сторінка"
          }
        },
        stepper: {
          next: "Далі",
          prev: "Назад"
        },
        rating: {
          ariaLabel: {
            item: "Оцінка {0} з {1}"
          }
        },
        loading: "Завантаження...",
        infiniteScroll: {
          loadMore: "Завантажити більше",
          empty: "Немає більше даних"
        },
        rules: {
          required: "Це поле є обов’язковим",
          email: "Будь ласка, введіть дійсну електронну адресу",
          number: "Це поле може містити лише цифри",
          integer: "Це поле може містити лише цілі числа",
          capital: "Це поле може містити лише великі літери",
          maxLength: "Ви повинні ввести максимум {0} символів",
          minLength: "Ви повинні ввести мінімум {0} символів",
          strictLength: "Довжина введеного поля є недійсною",
          exclude: "Символ {0} не дозволений",
          notEmpty: "Будь ласка, виберіть принаймні одне значення",
          pattern: "Недійсний формат"
        },
        hotkey: {
          then: "потім",
          ctrl: "Ctrl",
          command: "Command",
          shift: "Shift",
          alt: "Alt",
          option: "Option",
          enter: "Enter",
          escape: "Escape",
          upArrow: "Стрілка вгору",
          downArrow: "Стрілка вниз",
          leftArrow: "Стрілка вліво",
          rightArrow: "Стрілка вправо",
          backspace: "Backspace",
          space: "Пробіл",
          plus: "плюс",
          shortcut: "Комбінація клавіш: {0}"
        },
        video: {
          play: "Відтворити",
          pause: "Пауза",
          seek: "Пошук",
          volume: "Гучність",
          showVolume: "Показати регулятор гучності",
          mute: "Вимкнути звук",
          unmute: "Увімкнути звук",
          enterFullscreen: "На весь екран",
          exitFullscreen: "Вийти з повноекранного режиму"
        },
        colorPicker: {
          ariaLabel: {
            eyedropper: "Вибрати колір з екрана",
            hueSlider: "Відтінок",
            alphaSlider: "Прозорість",
            redInput: "Червоний",
            greenInput: "Зелений",
            blueInput: "Синій",
            alphaInput: "Прозорість",
            hueInput: "Відтінок",
            saturationInput: "Насиченість",
            lightnessInput: "Яскравість",
            hexInput: "HEX значення",
            hexaInput: "HEX зі значенням прозорості",
            changeFormat: "Змінити формат кольору"
          }
        }
      }
    }
  },
  numberFormats: {
    "en-US": {
      currency: {
        style: "currency",
        currency: "USD"
      }
    }
  },
  pluralRules: {
    uk: function (choice, choicesLength) {
      const n = Math.abs(choice);
      if (choicesLength === 1) {
        return 0;
      }
      if (n % 10 === 1 && n % 100 !== 11) {
        return 0;
      }
      if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return 1;
      }
      return 2;
    }
  },
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "uk",
    countryCode: "ua",
    iso: "uk-UA",
    name: "Українська",
    files: [
      {
        path: "/app/build/projects/Kredo/locales/uk.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/